
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 여행후기 {{ $route.query.travel_review_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.travel_review_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_review_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.travelReviewTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelReviewTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_top_status'>상단 공지<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_review_top_status"
                v-model="formData.travelReviewTopStatus"
              >
                <option value='0'>미공지</option>
                <option value='1'>공지</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_write'>작성자<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_review_write'
                maxLength="10"
                placeholder = "작성자를 입력해 주세요.(10자 이내)"
                v-model="formData.travelReviewWrite"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelReviewWriteError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_email'>작성자<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_review_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요.(50자 이내)"
                v-model="formData.travelReviewEmail"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_views'>조회수</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_review_views'
                readonly
                v-model="formData.travelReviewViews"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_status'>노출 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_review_status"
                v-model="formData.travelReviewStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='travel_review_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.travel_review_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'travel_review_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_SquareBanner">
                  <img
                    :src="formData.travelReviewMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.travelReviewMainImageURL"
                    alt="노출 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.travelReviewMainImageURLError}}</p>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_review_editor'>내용</label>
              <custom-textarea
                v-model="formData.travelReviewEditor"
                :id="'travel_review_editor'"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_travel_review_one,
  insert_travel_review,
  update_travel_review,
  get_session_admin

} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTravelReviewManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        travelReviewTitle: '',
        travelReviewTopStatus: '0',
        travelReviewWrite: '',
        travelReviewEmail: '',
        travelReviewViews: '0',
        travelReviewStatus: 1,
        travelReviewMainImage: '',
        travelReviewMainImageURL: '',
        travelReviewEditor: ''
      }),
      errorData: ref({
        travelReviewTitleError: '',
        travelReviewWriteError: '',
        travelReviewMainImageURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.travelReviewMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.travelReviewMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      if (this.formData.travelReviewTitle === '') {
        this.errorData.travelReviewTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.travelReviewTitleError = ''
      }
      if (this.formData.travelReviewWrite === '') {
        this.errorData.travelReviewWriteError = '작성자를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.travelReviewWriteError = ''
      }
      if (this.formData.travelReviewMainImageURL === '') {
        this.errorData.travelReviewMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.travelReviewMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.travel_review_ID === undefined) {
          insert_travel_review(
            this.formData.travelReviewTitle,
            this.formData.travelReviewTopStatus,
            this.formData.travelReviewWrite,
            this.formData.travelReviewEmail,
            this.formData.travelReviewMainImage,
            this.formData.travelReviewEditor,
            this.formData.travelReviewStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminTravelReviewManagement'
          })
        } else {
          update_travel_review(
            this.$route.query.travel_review_ID,
            this.formData.travelReviewTitle,
            this.formData.travelReviewTopStatus,
            this.formData.travelReviewWrite,
            this.formData.travelReviewEmail,
            this.formData.travelReviewMainImage,
            this.formData.travelReviewEditor,
            this.formData.travelReviewStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminTravelReviewManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.travel_review_ID !== undefined) {
      get_travel_review_one(this.$route.query.travel_review_ID).then((result) => {
        this.formData.travelReviewTitle = result.travel_review[0].travel_review_title
        this.formData.travelReviewTopStatus = result.travel_review[0].travel_review_top_status
        this.formData.travelReviewWrite = result.travel_review[0].travel_review_write
        this.formData.travelReviewEmail = result.travel_review[0].travel_review_email
        this.formData.travelReviewViews = result.travel_review[0].travel_review_views
        this.formData.travelReviewStatus = result.travel_review[0].travel_review_status
        this.formData.travelReviewMainImageURL = result.travel_review[0].travel_review_main_image
        this.formData.travelReviewEditor = result.travel_review[0].travel_review_editor
      })
    } else {
      get_session_admin().then(result => {
        if (result === '') {
          alert('로그인 유지시간이 만료되었습니다.')
          window.location.href = '/AdminLogin'
        } else {
          this.formData.travelReviewWrite = result.admin_name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminTravelReviewManagementAdd.vue